import React, { useContext } from 'react'
import { MainContext } from '../../context/Main.context';
import { Ellispis } from '../MorphoTab/MorphoTab.styled';
import { Tab } from '../Tab/Tab';
import { Item, ItemLink, ItemsList } from './WelcomeTab.styled';

export const WelcomeTab = () => {
    const { 
        currentFormTab,
    } = useContext(MainContext);
    return (
        <Tab show={currentFormTab === -1}>
            <p><strong>Important :</strong> Tout dossier incomplet ne pourra être validé </p>
            <h3>Notice explicative pour les licences</h3>
            <h4>Liens utiles</h4>
            <ItemsList>
                <Item>
                    Certificat médical de la FFHB &rarr;&nbsp;
                    <ItemLink 
                        href='https://res.cloudinary.com/ffhb-production/image/upload/v1654766262/ffhb-prod/assets/2022-23_certificat_medical.pdf' target={"_blank"}
                        download
                        rel="noreferrer"
                    >
                        télécharger
                    </ItemLink>
                </Item>
            </ItemsList>
            <h4>Etapes pour la création de la licence</h4>
            <ItemsList>
                <Item>
                    Pour créer un dossier, il faut impérativement la fiche de renseignement du club, vous
                    pouvez la retrouver en version papier ou informatique sur le site du club. Merci de
                    préciser l’adresse mail sur laquelle le formulaire de licence sera envoyé par la FFHB
                    (fédération française de handball).
                </Item>
                <Item>
                    Vous recevrez par la suite un lien vous permettant de remplir le formulaire FFHB.
                </Item>
                <Ellispis>Dans le cas d'un licencié mineur l'adresse mail du responsable légal 1 sera utilisée pour le formulaire FFHB.</Ellispis>
                <Item>
                    Pour une création de licence ou un changement d’adresse mail, une demande de
                    confirmation vous sera envoyée <strong>avant</strong> de pouvoir vous envoyer le formulaire.
                </Item>
            </ItemsList>
            <strong>⚠️ Pensez à regarder dans les « spams » ou les « indésirables »</strong>
            <p>Si vous remplissez la fiche de renseignement en ligne à partir du site du club, la licence sera validée uniquement à la réception du paiement.</p>
            <h4>ETAPES A SUIVRE POUR REMPLIR VOTRE DOSSIER DE LICENCE DE LA FFHB</h4>
            <ItemsList>
                <Item>
                    Pour un joueur, cochez la mention « handball à 7 »
                </Item>
                <strong>
                    Si vous êtes dans le cas d'un licence majeur, la validation de votre licence ne pourra se faire que si vous avez signé le certificat d’honorabilité, pour cela vous devez :
                </strong>   
                <Item>
                    Cochez <strong>« Je reconnais avoir été informé par la FFHB que :... »</strong>
                </Item>
                <Item>
                    Cochez <strong>« j’exerce ou je serai amené à exercer sur la saison 2022-23 une ou plusieurs fonctions d’encadrant listées ci dessus »</strong>
                </Item>
                <strong>Il peut vous être demandé d’insérer :</strong>
                <Item>
                    Votre photo <strong>(format jpeg)</strong>
                </Item>
                <Item>
                    Un justificatif d’identité (recto de la carte d’identité ou passeport - <strong>format pdf</strong>)
                </Item>
                <Item>
                    Un certificat médical (télécharger le modèle sur le site du club ou si votre médecin fait le
                    certificat sur un papier libre il doit impérativement inscrire <strong>votre nom, prénom et date de
                    naissance</strong> ainsi que la mention <strong>« pratique du handball en compétition »</strong>)
                </Item>
                <strong>
                    Vous devez fournir un certificat médical si :
                </strong>
                <Item>
                    Celui-ci est n’est pas déjà présent dans les documents à fournir
                </Item>
                <Item>
                    Si dans le <strong>questionnaire de santé</strong> vous avez répondu "oui" à l’une des questions
                </Item>
                <strong>Dans le cas contraire vous devez remplir le questionnaire de santé</strong>
            </ItemsList>
            <p>L’original du certificat médical doit impérativement être fourni au club pour être archivé pendant 10 ans.</p>
            <p>Si vous rencontrez des difficultés pour remplir votre dossier des permanences se tiendront au club.</p>
        </Tab>
    )
}
